import { SCROLL_LOCK_KEY } from '../layout.const'

import { isNodeInsideDrawer } from './isNodeInsideDrawer'

type Params = {
  scrollContainer: HTMLElement
  drawerElement: HTMLElement | null
}

export const preventScrollBehindDrawer = ({ scrollContainer, drawerElement }: Params): (() => void) => {
  const lockedScrollTop = scrollContainer.scrollTop

  const onScroll = () => {
    if (scrollContainer.scrollTop !== lockedScrollTop) {
      scrollContainer.scrollTop = lockedScrollTop
    }
  }

  const onWheel = (event: WheelEvent) => {
    if (isNodeInsideDrawer(event.target, drawerElement)) {
      return
    }

    event.preventDefault()
  }

  const onTouchMove = (event: TouchEvent) => {
    if (isNodeInsideDrawer(event.target, drawerElement)) {
      return
    }

    event.preventDefault()
  }

  const onKeyDown = (event: KeyboardEvent) => {
    if (!SCROLL_LOCK_KEY.has(event.key) || isNodeInsideDrawer(event.target, drawerElement)) {
      return
    }

    event.preventDefault()
  }

  scrollContainer.addEventListener('scroll', onScroll, { passive: true })
  scrollContainer.addEventListener('wheel', onWheel, { passive: false })
  scrollContainer.addEventListener('touchmove', onTouchMove, { passive: false })
  document.addEventListener('keydown', onKeyDown)

  return () => {
    scrollContainer.removeEventListener('scroll', onScroll)
    scrollContainer.removeEventListener('wheel', onWheel)
    scrollContainer.removeEventListener('touchmove', onTouchMove)
    document.removeEventListener('keydown', onKeyDown)
  }
}
